import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6107ccdc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6107ccdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107ccdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6107ccdc')) {
      api.createRecord('6107ccdc', component.options)
    } else {
      api.reload('6107ccdc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6107ccdc&scoped=true", function () {
      api.rerender('6107ccdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/returnNoteRecord/index.vue"
export default component.exports